import {computed} from 'vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {useCalculatorVersion} from '@/components/calculator/useCalculatorVersion';

// The zoom toggle has exactly one home. In the old comparator that is the calculator
// navigation header — but only from md up, because below md the header drops it and the
// horizontal navigation bar carries it instead. The new comparator never puts it in the
// header, so there the bar is always on.
//
// The md half of that switch is left to CSS on both sides, so the two can never disagree:
// what renders is decided here, where it is visible is decided by the mirrored classes.
export const useSimulationHorizontalNavigation = () => {
  const store = useSimulationStore();
  const {isNewMortgageComparator,} = useCalculatorVersion();

  const isNavigationZoomRendered = computed<boolean>(() => !isNewMortgageComparator.value);
  const navigationZoomClass = 'hidden md:block';

  const isHorizontalNavigationRendered = computed<boolean>(() => store.resultsTab === 'offers');
  // Vuetify's `d-flex` on the bar carries !important, so hiding it needs one too.
  const horizontalNavigationClass = computed<string>(() =>
    isNavigationZoomRendered.value ? 'md:hidden!' : '');

  // The bar's height, published to the offers column: it sets the bar's own height and the
  // offers listing subtracts it, so the table stops above the bar instead of scrolling
  // underneath it. Zero wherever the bar is hidden.
  const offersColumnNavClass = computed<string>(() => {
    if (!isHorizontalNavigationRendered.value) {
      return '';
    }
    return isNavigationZoomRendered.value
      ? '[--simulation-nav-height:48px] md:[--simulation-nav-height:0px]'
      : '[--simulation-nav-height:48px]';
  });

  return {
    isNavigationZoomRendered,
    navigationZoomClass,
    isHorizontalNavigationRendered,
    horizontalNavigationClass,
    offersColumnNavClass,
  };
};
